import type { ComponentRegistry } from '@vibesites/runtime';
import {
  Header,
  Hero,
  PropertyOverview,
  SpecialOffers,
  CTASection,
  TabbedCallouts,
  DiscoverAmenities,
  FullBleedStripe,
  FloorplansList,
  AmenitiesIntro,
  AmenitiesList,
  AmenitiesFeatures,
  GalleryIntro,
  GalleryPhotos,
  NeighborhoodMap,
  VirtualTourEmbed,
  ContactForm,
  ContactMap,
  ScheduleTourForm,
  Fees,
  PetPolicy,
  PageHero,
  PageBlurb,
  HeroSolidBG,
  HeroImageBG,
  Reviews,
  ReviewsCallout,
  PinnedCallouts,
  SocialFollow,
  SpecialOfferBanner,
  ResidentAccess,
  ApplyNowOptions,
  AccessibilityStatement,
  PrivacyPolicyContent,
  SitemapContent,
  HyperlocalHero,
  HyperlocalPageCopy,
  HyperlocalExplore,
  ThankYouContent,
  FutureResidentsClub,
  ApartmentSyncSection,
  FloorPlansIntro,
  VirtualTourIntro,
  NeighborhoodIntro,
  Footer,
  Navigation,
  InteractiveMapSection,
} from './components';

export const registry: ComponentRegistry = {
  Header,
  Hero,
  PropertyOverview,
  SpecialOffers,
  CTASection,
  TabbedCallouts,
  DiscoverAmenities,
  FullBleedStripe,
  FloorplansList,
  AmenitiesIntro,
  AmenitiesList,
  AmenitiesFeatures,
  GalleryIntro,
  GalleryPhotos,
  NeighborhoodMap,
  VirtualTourEmbed,
  ContactForm,
  ContactMap,
  ScheduleTourForm,
  Fees,
  PetPolicy,
  PageHero,
  PageBlurb,
  HeroSolidBG,
  HeroImageBG,
  Reviews,
  ReviewsCallout,
  PinnedCallouts,
  SocialFollow,
  SpecialOfferBanner,
  ResidentAccess,
  ApplyNowOptions,
  AccessibilityStatement,
  PrivacyPolicyContent,
  SitemapContent,
  HyperlocalHero,
  HyperlocalPageCopy,
  HyperlocalExplore,
  ThankYouContent,
  FutureResidentsClub,
  ApartmentSyncSection,
  FloorPlansIntro,
  VirtualTourIntro,
  NeighborhoodIntro,
  Footer,
  Navigation,
  InteractiveMapSection,
};

export default registry;
